<template lang="pug">
  .dashboard
    carousel.carousel(
      :per-page="8"
      :items="dashboard"
      interval="30000"
      v-if="hasData"
    )
      template(slot="renderItem" slot-scope="scope")
        v-container(
          grid-list-lg
          fill-height
          fluid
        )
          v-layout(
            row
            fill-height
            wrap
          )
            v-flex(xs12).py-0.my-0
              v-layout(
                row
                wrap
                justify-start
                align-center
              )
                v-flex(
                  xs2
                  md3
                ).py-0.my-0
                  span.dashboard-title Dashboard de dispositivos
                v-flex(
                  xs10
                  md9
                )
                  .top-line
                v-flex(
                  xs3
                  v-for="item in scope.renderItem"
                  :key="item.id"
                )
                  ativo-card(:ativo="item" :filial-id="filialId")
    v-layout(
      v-else
      fill-height
      justify-center
      align-center
    )
      span.error-message Erro ao buscar os ativos da filial
    div.bottom-bar
      v-img.ml-1(
        :src="logo"
      )
</template>

<script>
import DashboardService from '@/services/DashboardService';
import Logo from '@/assets/LogoMondonex_branca.svg';
import AtivoCard from './components/AtivoCard';
import Carousel from './components/Carousel';

export default {
  name: 'Dashboard',
  components: {
    AtivoCard,
    Carousel,
  },
  data() {
    return {
      logo: Logo,
      dashboard: [],
      filialId: '',
      hasData: true,
    };
  },
  created() {
    this.filialId = localStorage.getItem('filialId');
    this.getDashboard(this.filialId);
    setInterval(() => {
      this.getDashboard(this.filialId);
    }, 300000);
  },
  methods: {
    getDashboard(filialId) {
      DashboardService
        .getDashboard(filialId)
        .then(({ data }) => {
          this.dashboard = data;
        })
        .catch(() => {
          this.hasData = false;
        });
    },
  },
};
</script>

<style lang="sass" scoped>
.dashboard
  height: 100%
  .carousel
    background-color: #E5E5E5
  .dashboard-title
    font-size: 2.4vh
    line-height: 2.8vh
    color: #757575
  .top-line
    border: 0.1vh solid #E0E0E0
    width: 100%
    height: 0px
  .center-message
    width: 100%
    background: red
  .bottom-bar
    position: fixed
    left: 0
    bottom: 0
    width: 100%
    height: 4.0vh
    background: #2CB5FF
    border: 1px solid #279FE0
  .bottom-bar > .v-image
    max-height: 3.6vh !important
    max-width: 17vh !important
  .dashboard > .carousel > .v-window .v-carousel > .v-carousel__controls
    height: 4vh !important
  .error-message
    font-size: 4vh
    color: red
    opacity: 0.5
</style>



// WEBPACK FOOTER //
// src/app/Dashboard/Dashboard.vue